import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import styles from './styles.module.css';

export const AppTemplate = ({ navigation }: { navigation?: ReactNode }) => {
  return (
    <div className={styles.layout}>
      {navigation && <div className={styles.nav}>{navigation}</div>}
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};
